import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivityStreamState } from '../../data/activity-stream.state';
import { ActivityStreamItem } from '@coin/shared/activity-stream/util';
import { Store } from '@ngxs/store';

interface Section {
  name: string;
  backgroundColor: string;
  icon: string;
}

@Component({
  selector: 'coin-c-activity-stream-header',
  templateUrl: './activity-stream-header.component.html',
  styleUrls: ['./activity-stream-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActivityStreamHeaderComponent {
  private store = inject(Store);

  items$ = this.store.select<ActivityStreamItem[]>(ActivityStreamState.items);

  public sections: Section[] = [
    {
      name: 'activity-stream.event-details',
      backgroundColor: 'var(--lightgrey100)',
      icon: 'event'
    },
    {
      name: 'activity-stream.event-by',
      backgroundColor: 'var(--lightgrey200)',
      icon: 'group'
    },
    {
      name: 'activity-stream.date',
      backgroundColor: 'var(--petrol200)',
      icon: 'schedule'
    }
  ];
}
